import React from "react";
import "./VirasatHomePage.scss"
import Navbar from "../../components/Navbar/Navbar";
import bg from "../../assets/bg.jpg"
import Footer from "../../components/Footer/Footer";
import SubscriptionComponent from "../../components/SubscriptionComponent/SubscriptionComponent";
const VirasatHomePage = () => {
    return (
        <div className="VirasatHomePage" style={{
            backgroundImage: `linear-gradient(
                                        to bottom,
                                        rgba(20, 20, 20, 0.8) 50%, 
                                        rgba(66, 66, 66, 0.5) 100%
                                      ), url(${bg})`
        }}>
            <Navbar selected={"HOME"} />
            <div className="VirasatHomePage-container">
                <div className="VirasatHomePage-container-wrapper">
                    <div className="VirasatHomePage-hero-header-cont">
                        <div className="VirasatHomePage-hero-header">VIRASAT</div>
                        <div className="VirasatHomePage-hero-subheader">FINE DINING INDIAN RESTAURANT</div>
                    </div>
                    <div className="VirasatHomePage-hero-bottom-cont">
                        <div className="VirasatHomePage-hero-open">OPENING SOON</div>
                        <div className="border-line-hero" />
                    </div>
                </div>

            </div>
            <SubscriptionComponent />
            <Footer />
        </div>
    )
}
export default VirasatHomePage